import React from "react";
import hero from '../asset/hero.png';

const Hero = () => {
    return (
        <section className="bg-custom-green2 text-white py-20 flex">
            
            {/* Bagian Teks */}
            <div className="flex flex-col justify-center items-start text-left p-16 w-1/2">
                <h1 className="text-4xl font-bold mt-4">Hello</h1>
                <h1 className="text-4xl font-bold mt-4">I'm imaa</h1>
                <p className="text-2xl mt-4 mb-8">Kidi Intern</p>
                <a href="#projects" className="bg-custom-orange2 text-white font-bold py-2 px-8 rounded-lg shadow-lg transition duration-300">
                    My Project
                </a>
            </div>

            {/* Bagian Gambar */}
            <div className="flex justify-center items-center w-1/2">
                <img 
                  src={hero} 
                  alt="Hero"
                  className="w-1/2 h-auto rounded-lg shadow-lg"
                />
            </div>

        </section>
    );
};

export default Hero;
